import * as moment from "moment";

require("../stylesheets/base.css");
require("../stylesheets/grid-system.css");
require("../stylesheets/grid-adaptively-system.css");
require("../stylesheets/reset-jquery-ui-font.css");
require("../stylesheets/autocomplete.css");
require("../stylesheets/dialog-alerts.css");
require("../stylesheets/dialog-modals.css");
require("../stylesheets/tooltips.css");
require("../stylesheets/login-register.css");
require("../../../phoenix/scss/_static-page.scss");
require("script-loader!../../node_modules/sprintf-js/src/sprintf.js");
require("script-loader!../../node_modules/jquery/dist/jquery.js");
require("script-loader!../../node_modules/jquery-ui-bundle/jquery-ui.js");
require("../../node_modules/jquery-ui-bundle/jquery-ui.css");
require("../../node_modules/jquery-ui-bundle/jquery-ui.structure.css");
require("../../node_modules/jquery-ui-bundle/jquery-ui.theme.css");
require("script-loader!../../node_modules/underscore/underscore-min.js");
require("script-loader!../../node_modules/backbone/backbone.js");
require("script-loader!../../node_modules/spin.js/spin.js");
require("script-loader!../../node_modules/moment/moment.js");
require("script-loader!../../node_modules/moment-timezone/builds/moment-timezone-with-data-10-year-range.js");

if (mx2_config.locale !== "en") {
  require("script-loader!../../node_modules/moment/locale/" +
    mx2_config.locale +
    ".js");
}
require("script-loader!../../node_modules/resig-class/index.js");
require("script-loader!../../node_modules/old-monthpicker/monthpicker.js");
require("../../node_modules/old-monthpicker/monthpicker.css");

require("./application.js");
require("./artists-roles.js");
require("./forms-buttons.js");
require("./shopping_cart.js");
require("./dialogs.js");
require("./jquery.ui.mx2.js");
require("./pager.js");
require("./page.js");
// This file MUST always be the last
require("./widgets.js");

const css = document.querySelectorAll("[data-tenant-css]")[0];
css.href = css.href.replace(/\?.*|$/, "?refresh=" + new Date().getTime());

/* MAKE UP */
require("../stylesheets/make-up/colors.css");
require("../stylesheets/make-up/components.css");
require("../stylesheets/make-up.css");
require("../stylesheets/make-up/tab__menu--release.css");
require("../stylesheets/make-up/input.css");
require("../stylesheets/make-up/input--textarea.css");
require("../stylesheets/make-up/icon__container.css");
require("../stylesheets/make-up/icon--chevron.css");
require("../stylesheets/make-up/icon--social.css");
require("../stylesheets/make-up/input--select.css");
require("../stylesheets/make-up/input--search.css");
require("../stylesheets/make-up/input--datapicker.css");
require("../stylesheets/make-up/input--date.css");
require("../stylesheets/make-up/input--time.css");
require("../stylesheets/make-up/icon--checkbox.css");
require("../stylesheets/make-up/input--radio.css");
require("../stylesheets/make-up/item__list--artist.css");
require("../stylesheets/make-up/button__make-up.css");
require("../stylesheets/make-up/button.css");
require("../stylesheets/make-up/button--ghost.css");
require("../stylesheets/make-up/button__primary.css");
require("../stylesheets/make-up/h2.css");
require("../stylesheets/make-up/h4.css");
require("../stylesheets/make-up/message__box.css");
require("../stylesheets/make-up/modal.css");
require("../stylesheets/make-up/modal-pop-up.css");
require("../stylesheets/make-up/releases-list.css");
require("../stylesheets/make-up/text.css");
require("../stylesheets/make-up/contributors-share.css");
require("../stylesheets/make-up/status-pill.css");
require("../stylesheets/make-up/search-box__make-up.css");

// eslint-disable-next-line no-undef
moment.locale(mx2_config.locale);
